module.exports = __webpack_public_path__ + "static/media/AWS-Dev-Associate.51df0293.png";